import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { differentiators } from "../data/differentiators";
import { ui } from "../data/ui";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
export function Differentiators() {
  const {
    t
  } = useLanguage();
  return <section id="about" aria-labelledby="about-title" className="bg-ink py-20 lg:py-28" data-id="element-107" data-mp="1w4uh7pf5ygur">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-108" data-mp="zetzgad7p0my">
        <SectionHeading id="about-title" align="center" title={t(ui.about.title)} subtitle={t(ui.about.subtitle)} data-id="element-109" data-mp="13fdtv66ehq5e" />

        <div className="mt-16 space-y-20 lg:space-y-28" data-id="element-110" data-mp="18buh7y5s00hf">
          {differentiators.map((item, i) => {
          const flip = i % 2 === 1;
          return <Reveal key={item.kicker.en} className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-111" data-mp="2jt42mq8gt2ld" data-mpi={i}>
                <div className={`relative ${flip ? "lg:order-2" : ""}`} data-id="element-112" data-mp="2oqw1y5bfvqzl">
                  <div className={`absolute -bottom-3 h-full w-full border border-gold/60 ${flip ? "-left-3" : "-right-3"}`} aria-hidden="true" data-id="element-113" data-mp="bokea0fqo7tu" />
                  <img src={item.image} alt={t(item.alt)} loading="lazy" decoding="async" className="relative aspect-[4/3] w-full object-cover" data-id="element-114" data-mp="2nvzv4mfo5gf" />
                </div>
                <div className={flip ? "lg:order-1" : ""} data-id="element-115" data-mp="3k4nlk52xvuhn">
                  <p className="text-xs font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-116" data-mp="3k32skjw9wjlw">{t(item.kicker)}</p>
                  <h3 className="mt-4 font-display text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-117" data-mp="3g3ai21nbk3dw">
                    {t(item.title)}
                  </h3>
                  <p className="mt-5 max-w-lg text-lg leading-relaxed text-smoke" data-id="element-118" data-mp="363jlzvj41gbp">{t(item.text)}</p>
                  <a href={item.href} className="mt-7 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-gold" data-id="element-119" data-mp="3172z14nnd807">
                    <span className="link-slide" data-id="element-120" data-mp="2wh8x9jhugr71">{t(item.link)}</span>
                    <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-121" data-mp="2wik11jbahyy5" />
                  </a>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}